import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from './app.state';

export const getAppState = createFeatureSelector<AppState>('app');

export const getVisibilityOfBackendErrorPopup = createSelector(getAppState, (state) => state.showBackendErrorPopup);

export const getVisibilityOfCustomerChat = createSelector(getAppState, (state) => state.showCustomerChat);

export const getVisibilityOfMaintenanceModeScreen = createSelector(
  getAppState,
  (state) => state.showMaintenanceModeScreen,
);

export const getVisibilityOfYouthHealthPackages = createSelector(getAppState, (state) => state.showYouthHealthPackages);

export const getVisibilityOfAdvancedMedicSearch = createSelector(getAppState, (state) => state.showAdvancedMedicSearch);

export const getVisibilityOfJevUnapprovedPremiumHint = createSelector(
  getAppState,
  (state) => state.showJevUnapprovedPremiumHint,
);
